import { axiosClient } from "@/lib/axiosClient";
import type { BlogData } from "@/models/news";

export const getPostByURL = (url: string) => axiosClient.get<{ data: BlogData }>(`/v1/blog/detail/${url}`);
export const fetchPostByURL = async (postURL: string) => {
  const postResponse = await getPostByURL(postURL);
  return postResponse.data.data;
};
export const countPostView = (postID: string) => axiosClient.put<{ data: BlogData }>(`/v1/blog/view/${postID}`);
